import { createSelector } from 'reselect'

import { connectLoadable } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import { referralInfoGuard } from 'guards/bountyGuards'
import { referralInfoSelector } from 'selectors/bountySelectors'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { InviteFriends, InviteFriendsProps } from 'components/features/inviteFriendsPane/containers/InviteFriends/InviteFriendsInfo'

const createMapStateToProps = () =>
  createSelector(
    referralInfoSelector,
    (info) => {
      if (!info) {
        throw createForgottenGuardError('InviteFriendsContainer', 'referralInfoGuard')
      }

      return info
    },
  )

const guards: Guards = [
  referralInfoGuard,
]

export const InviteFriendsContainer = connectLoadable<
  InviteFriendsProps
>(guards)(createMapStateToProps)(InviteFriends)
